var map = {
	"./animation.js": 48072,
	"./blur.js": 1617,
	"./borders.js": 26189,
	"./brush.js": 35650,
	"./bulge_pinch.js": 99642,
	"./circle.js": 5608,
	"./clone.js": 99527,
	"./crop.js": 94826,
	"./desaturate.js": 3754,
	"./erase.js": 40876,
	"./fill.js": 94693,
	"./gradient.js": 67516,
	"./grid.js": 23484,
	"./line.js": 29042,
	"./magic_wand.js": 57310,
	"./media.js": 20686,
	"./palette256.js": 62568,
	"./pencil.js": 10741,
	"./pick_color.js": 92277,
	"./rasterize.js": 36675,
	"./rectangle.js": 8743,
	"./select.js": 92064,
	"./selection.js": 79335,
	"./sharpen.js": 4769,
	"./text.js": 26411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61320;